module.exports = __webpack_public_path__ + "images/2072acbf4a6880a19c571f171b88de94-logoWhite.png";